/**
 * EDC Lanyard Builder — Car-Configurator UX
 * Multi-item cart: rope product + weave product + pendant(s)
 */
(function () {
  'use strict';

  document.querySelectorAll('.lanyard-builder').forEach(function (builder) {
    initBuilder(builder);
  });

  function initBuilder(builder) {
    var pendantCollectionHandle = builder.dataset.pendantCollectionHandle;
    if (!pendantCollectionHandle) return;

    var $ = function (sel) { return builder.querySelector(sel); };
    var $$ = function (sel) { return builder.querySelectorAll(sel); };

    // Request a resized copy from Shopify's CDN instead of the full-size original
    function sizedImageUrl(url, width) {
      if (!url || url.indexOf('cdn.shopify.com') === -1) return url;
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    // Step views
    var view1 = $('[data-step-view="1"]');
    var view2 = $('[data-step-view="2"]');
    var view3 = $('[data-step-view="3"]');
    var view4 = $('[data-step-view="4"]');
    var view4b = $('[data-step-view="4b"]');
    var view5 = $('[data-step-view="5"]');
    var noteTotalLength = $('[data-role="note-total-length"]');
    var noteLoopLength = $('[data-role="note-loop-length"]');
    var noteKnotCount = $('[data-role="note-knot-count"]');
    var noteCustomLetter = $('[data-role="note-custom-letter"]');
    var noteOther = $('[data-role="note-other"]');

    // Step nav buttons
    var navBtns = $$('.lb-steps-btn');

    // Option lists
    var ropeCards = $$('[data-role="rope-type-list"] .lb-rope-card');
    var colorList = $('[data-role="color-list"]');
    var weaveCards = $$('[data-role="weave-method-list"] .lb-weave-card');
    var pendantList1 = $('[data-role="pendant-list-1"]');
    var pendantList2 = $('[data-role="pendant-list-2"]');
    var loadMore1 = $('[data-role="load-more-1"]');
    var loadMore2 = $('[data-role="load-more-2"]');
    var samePendantBtn = $('[data-role="same-pendant"]');

    // Bottom bar
    var totalPriceEl = $('[data-role="total-price"]');
    var addToCartBtn = $('[data-role="add-to-cart"]');
    var errorEl = $('[data-role="error"]');
    var step5Recap = $('[data-role="step5-recap"]');

    // Bottom bar chips
    var chipRope = $('[data-role="chip-rope"]');
    var chipRopeImg = $('[data-role="chip-rope-img"]');
    var chipRopeLabel = $('[data-role="chip-rope-label"]');
    var chipColor = $('[data-role="chip-color"]');
    var chipColorImg = $('[data-role="chip-color-img"]');
    var chipColorLabel = $('[data-role="chip-color-label"]');
    var chipWeave = $('[data-role="chip-weave"]');
    var chipWeaveImg = $('[data-role="chip-weave-img"]');
    var chipWeaveLabel = $('[data-role="chip-weave-label"]');
    var chipP1 = $('[data-role="chip-pendant1"]');
    var chipP1Img = $('[data-role="chip-pendant1-img"]');
    var chipP1Label = $('[data-role="chip-pendant1-label"]');
    var chipP2 = $('[data-role="chip-pendant2"]');
    var chipP2Img = $('[data-role="chip-pendant2-img"]');
    var chipP2Label = $('[data-role="chip-pendant2-label"]');
    var sepColor = $('[data-role="sep-color"]');
    var sepWeave = $('[data-role="sep-weave"]');
    var sepP1 = $('[data-role="sep-pendant1"]');
    var sepP2 = $('[data-role="sep-pendant2"]');

    // ---- State ----
    var state = {
      ropeIndex: null, ropeName: null, ropeProductId: null, ropePrice: 0, ropeImage: null,
      colorName: null, colorImage: null,
      weaveIndex: null, weaveName: null, weaveProductId: null, weavePrice: 0, weaveNeedsTwo: false, weaveImage: null,
      pendant1Id: null, pendant1Price: 0, pendant1Name: null, pendant1Image: null,
      pendant2Id: null, pendant2Price: 0, pendant2Name: null, pendant2Image: null,
    };

    // ---- localStorage Persistence ----
    var LS_KEY = 'edc-lanyard-state';

    function saveState() {
      var data = {
        ropeIndex: state.ropeIndex, ropeName: state.ropeName, ropeProductId: state.ropeProductId, ropePrice: state.ropePrice, ropeImage: state.ropeImage,
        colorName: state.colorName, colorImage: state.colorImage,
        weaveIndex: state.weaveIndex, weaveName: state.weaveName, weaveProductId: state.weaveProductId, weavePrice: state.weavePrice, weaveNeedsTwo: state.weaveNeedsTwo, weaveImage: state.weaveImage,
        pendant1Id: state.pendant1Id, pendant1Price: state.pendant1Price, pendant1Name: state.pendant1Name, pendant1Image: state.pendant1Image,
        pendant2Id: state.pendant2Id, pendant2Price: state.pendant2Price, pendant2Name: state.pendant2Name, pendant2Image: state.pendant2Image,
        maxUnlockedStep: maxUnlockedStep, currentStep: currentStep,
        totalLength: noteTotalLength ? noteTotalLength.value : '',
        loopLength: noteLoopLength ? noteLoopLength.value : '',
        knotCount: noteKnotCount ? noteKnotCount.value : '',
        customLetter: noteCustomLetter ? noteCustomLetter.value : '',
        otherNotes: noteOther ? noteOther.value : ''
      };
      try { localStorage.setItem(LS_KEY, JSON.stringify(data)); } catch (e) {}
    }

    function loadState() {
      try {
        var raw = localStorage.getItem(LS_KEY);
        if (!raw) return false;
        var data = JSON.parse(raw);
        if (data.ropeName) { state.ropeIndex = data.ropeIndex; state.ropeName = data.ropeName; state.ropeProductId = data.ropeProductId; state.ropePrice = data.ropePrice; state.ropeImage = data.ropeImage; }
        if (data.colorName) { state.colorName = data.colorName; state.colorImage = data.colorImage; }
        if (data.weaveName) { state.weaveIndex = data.weaveIndex; state.weaveName = data.weaveName; state.weaveProductId = data.weaveProductId; state.weavePrice = data.weavePrice; state.weaveNeedsTwo = data.weaveNeedsTwo; state.weaveImage = data.weaveImage; }
        if (data.pendant1Id) { state.pendant1Id = data.pendant1Id; state.pendant1Price = data.pendant1Price; state.pendant1Name = data.pendant1Name; state.pendant1Image = data.pendant1Image; }
        if (data.pendant2Id) { state.pendant2Id = data.pendant2Id; state.pendant2Price = data.pendant2Price; state.pendant2Name = data.pendant2Name; state.pendant2Image = data.pendant2Image; }
        if (data.maxUnlockedStep) maxUnlockedStep = data.maxUnlockedStep;
        if (data.currentStep) currentStep = data.currentStep;
        if (data.totalLength && noteTotalLength) noteTotalLength.value = data.totalLength;
        if (data.loopLength && noteLoopLength) noteLoopLength.value = data.loopLength;
        if (data.knotCount && noteKnotCount) noteKnotCount.value = data.knotCount;
        if (data.customLetter && noteCustomLetter) noteCustomLetter.value = data.customLetter;
        if (data.otherNotes && noteOther) noteOther.value = data.otherNotes;
        return true;
      } catch (e) { return false; }
    }

    // ---- URL Params (bead deep link) ----
    function getParam(name) {
      var m = (location.search || '').match(new RegExp('[?&]' + name + '=([^&]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    }
    var maxUnlockedStep = 1;
    var currentStep = 1;

    // Restore saved selections first, then apply any bead deep link on top
    loadState();

    var beadParamId = getParam('bead_id');
    if (beadParamId) {
      // Deep-linked bead from a product page overrides the saved bead selection
      state.pendant1Id = beadParamId;
      state.pendant1Price = parseFloat(getParam('bead_price')) || 0;
      state.pendant1Name = getParam('bead_name');
      state.pendant1Image = getParam('bead_img');
      saveState();
      // Strip params so a page refresh restores from localStorage instead of resetting state
      try { window.history.replaceState(null, '', location.pathname); } catch (e) {}
    }

    // ---- Rope data ----
    var allRopeData = [];
    var colorScripts = $$('[data-role="rope-colors"]');
    ropeCards.forEach(function (card, i) {
      var colors = [];
      colorScripts.forEach(function (s) {
        if (parseInt(s.dataset.ropeIndex, 10) === i) {
          try { colors = JSON.parse(s.textContent.trim()); } catch (e) {}
        }
      });
      allRopeData.push({
        index: i,
        name: card.dataset.ropeName,
        productId: card.dataset.ropeProductId || null,
        price: parseFloat(card.dataset.ropeProductPrice) || 0,
        image: card.querySelector('img') ? card.querySelector('img').src : '',
        colors: colors,
      });
    });

    // ---- Step Navigation ----
    function showStep(n) {
      currentStep = n;
      if (n === 5) unlockStep(5);
      [view1, view2, view3, view4, view4b, view5].forEach(function (v) {
        if (v) v.classList.remove('lb-step-view--active');
      });
      var target = n === '4b' ? view4b : n === 5 ? view5 : [view1, view2, view3, view4][n - 1];
      if (target) target.classList.add('lb-step-view--active');
      updateNavButtons();
      refreshSelectedUI();
      saveState();
    }

    function updateNavButtons() {
      navBtns.forEach(function (btn) {
        var s = parseInt(btn.dataset.navStep, 10);
        btn.classList.remove('lb-steps-btn--active', 'lb-steps-btn--done');
        btn.disabled = true;
        if ((s === currentStep || (currentStep === '4b' && s === 4))) {
          btn.classList.add('lb-steps-btn--active');
          btn.disabled = false;
        } else if (s < maxUnlockedStep && isStepDone(s)) {
          btn.classList.add('lb-steps-btn--done');
          btn.disabled = false;
        }
      });
    }

    function isStepDone(n) {
      if (n === 1) return state.ropeIndex !== null;
      if (n === 2) return state.colorName !== null;
      if (n === 3) return state.weaveIndex !== null;
      if (n === 4) return state.pendant1Id !== null;
      if (n === 5) return state.pendant1Id !== null;
      return false;
    }

    function unlockStep(n) {
      if (n > maxUnlockedStep) maxUnlockedStep = n;
    }

    navBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var s = parseInt(btn.dataset.navStep, 10);
        if (!btn.disabled) goToStep(s);
      });
    });

    function goToStep(n) {
      if (n === currentStep) return;
      if (n >= 2 && state.ropeIndex !== null && allRopeData[state.ropeIndex]) {
        renderColors(allRopeData[state.ropeIndex].colors);
      }
      showStep(n);
    }

    // Clear selections from a given step onward (used when a pick changes upstream)
    function clearDownstream(fromStep) {
      if (fromStep <= 2) { state.colorName = null; state.colorImage = null; }
      if (fromStep <= 3) { state.weaveIndex = null; state.weaveName = null; state.weaveProductId = null; state.weavePrice = 0; state.weaveNeedsTwo = false; state.weaveImage = null; }
      if (fromStep <= 4) {
        state.pendant1Id = null; state.pendant1Price = 0; state.pendant1Name = null; state.pendant1Image = null;
        state.pendant2Id = null; state.pendant2Price = 0; state.pendant2Name = null; state.pendant2Image = null;
        view4b.style.display = 'none'; view4b.classList.remove('lb-step-view--active');
        if (samePendantBtn) samePendantBtn.style.display = 'none';
        hidePreselectedBead();
      }
      maxUnlockedStep = Math.min(maxUnlockedStep, fromStep);
    }

    // ---- STEP 1: Rope Type ----
    ropeCards.forEach(function (card, i) {
      card.addEventListener('click', function () { selectRope(i); });
    });

    function selectRope(index) {
      if (state.ropeIndex !== null && state.ropeIndex !== index) {
        clearDownstream(2);
      }
      var data = allRopeData[index];
      state.ropeIndex = index; state.ropeName = data.name; state.ropeProductId = data.productId; state.ropePrice = data.price; state.ropeImage = data.image;
      ropeCards.forEach(function (c) { c.classList.remove('lb-rope-card--selected'); });
      ropeCards[index].classList.add('lb-rope-card--selected');
      renderColors(data.colors);
      unlockStep(2);
      updateSelections();
      updatePrice();
      updateCTA();
      saveState();
      setTimeout(function () { showStep(2); }, 300);
    }

    // ---- STEP 2: Color (paginated) ----
    var ITEMS_PER_PAGE = 8;
    var PENDANTS_PER_PAGE = window.innerWidth < 750 ? 6 : 12;
    var pendantTotal = parseInt(builder.dataset.pendantTotalCount, 10) || 0;
    var allColors = [];
    var colorPage = 0;
    var colorTotalPages = 0;

    function renderColors(colors) {
      allColors = colors;
      colorPage = 0;
      // Jump to the page containing the previously selected color
      if (state.colorName) {
        for (var k = 0; k < colors.length; k++) {
          if (colors[k].name === state.colorName) { colorPage = Math.floor(k / ITEMS_PER_PAGE); break; }
        }
      }
      colorTotalPages = Math.ceil(colors.length / ITEMS_PER_PAGE) || 1;
      renderColorPage();
    }

    function renderColorPage() {
      colorList.innerHTML = '';
      if (!allColors.length) { colorList.innerHTML = '<p class="lb-placeholder-text">No colors available</p>'; return; }

      var isMobile = window.innerWidth < 750;
      var start = isMobile ? 0 : colorPage * ITEMS_PER_PAGE;
      var end = isMobile ? allColors.length : Math.min(start + ITEMS_PER_PAGE, allColors.length);

      // Pagination bar — desktop only
      var oldColorBar = document.querySelector('[data-pagination="color"]');
      if (oldColorBar) oldColorBar.remove();
      if (!isMobile) {
        var bar = makePagination('color', colorPage, colorTotalPages,
          function () { colorPage = Math.max(0, colorPage - 1); renderColorPage(); },
          function () { colorPage = Math.min(colorTotalPages - 1, colorPage + 1); renderColorPage(); }
        );
        colorList.after(bar);
      }

      for (var i = start; i < end; i++) {
        (function (idx) {
          var color = allColors[idx];
          var wrap = document.createElement('div');
          wrap.className = 'lb-color-item';
          var btn = document.createElement('button');
          btn.className = 'lb-color-swatch';
          btn.title = color.name || '';
          if (state.colorName && color.name === state.colorName) btn.classList.add('lb-color-swatch--selected');
          if (color.image) {
            var img = document.createElement('img');
            img.src = sizedImageUrl(color.image, 300); img.alt = color.name || ''; img.width = 72; img.height = 72;
            img.loading = 'lazy';
            btn.appendChild(img);
          } else if (color.hex) { btn.style.background = color.hex; }
          else { btn.style.background = '#ccc'; }
          btn.addEventListener('click', function () { selectColor(idx, color); });
          wrap.appendChild(btn);
          var label = document.createElement('span');
          label.className = 'lb-color-name';
          label.textContent = color.name || '';
          wrap.appendChild(label);
          colorList.appendChild(wrap);
        })(i);
      }
    }

    function selectColor(index, color) {
      state.colorName = color.name || ''; state.colorImage = color.image || '';
      var swatches = colorList.querySelectorAll('.lb-color-swatch');
      swatches.forEach(function (s) { s.classList.remove('lb-color-swatch--selected'); });
      if (swatches[index - (colorPage * ITEMS_PER_PAGE)]) swatches[index - (colorPage * ITEMS_PER_PAGE)].classList.add('lb-color-swatch--selected');
      unlockStep(3);
      updateSelections();
      updatePrice();
      updateCTA();
      saveState();
      setTimeout(function () { showStep(3); }, 300);
    }

    // ---- STEP 3: Weave ----
    weaveCards.forEach(function (card) {
      card.addEventListener('click', function () { selectWeave(card); });
    });

    function selectWeave(card) {
      state.weaveIndex = parseInt(card.dataset.weaveIndex, 10);
      state.weaveName = card.dataset.weaveName;
      state.weaveProductId = card.dataset.weaveProductId || null;
      state.weavePrice = parseFloat(card.dataset.weaveProductPrice) || 0;
      state.weaveNeedsTwo = card.dataset.weaveNeedsTwoPendants === 'true';
      state.weaveImage = card.querySelector('img') ? card.querySelector('img').src : '';

      weaveCards.forEach(function (c) { c.classList.remove('lb-weave-card--selected'); });
      card.classList.add('lb-weave-card--selected');

      if (state.weaveNeedsTwo) {
        view4b.style.display = '';
        if (samePendantBtn) samePendantBtn.style.display = 'block';
      } else {
        view4b.style.display = 'none';
        view4b.classList.remove('lb-step-view--active');
        state.pendant2Id = null; state.pendant2Price = 0; state.pendant2Name = null; state.pendant2Image = null;
      }

      unlockStep(4);
      updateSelections();
      updatePrice();
      updateCTA();
      saveState();
      setTimeout(function () { showStep(4); }, 300);
    }

    // ---- STEP 4a: Pendant 1 ----
    pendantList1.addEventListener('click', function (e) {
      var card = e.target.closest('.lb-pendant-card');
      if (!card) return;
      var zoomBtn = e.target.closest('.lb-pendant-zoom');
      if (zoomBtn) {
        var zoomImg = card.querySelector('img');
        if (zoomImg && zoomImg.src) openZoom(zoomImg.src);
        return;
      }
      state.pendant1Id = card.dataset.pendantId;
      state.pendant1Price = parseFloat(card.dataset.pendantPrice) || 0;
      state.pendant1Name = card.dataset.pendantName || '';
      state.pendant1Image = card.querySelector('img') ? card.querySelector('img').src : '';
      pendantList1.querySelectorAll('.lb-pendant-card').forEach(function (c) { c.classList.remove('lb-pendant-card--selected'); });
      card.classList.add('lb-pendant-card--selected');
      hidePreselectedBead();
      updateSelections();
      updatePrice();
      updateCTA();
      saveState();
      if (state.weaveNeedsTwo) {
        setTimeout(function () { showStep('4b'); }, 300);
      } else {
        setTimeout(function () { showStep(5); }, 300);
      }
    });

    // ---- STEP 4b: Pendant 2 ----
    pendantList2.addEventListener('click', function (e) {
      var card = e.target.closest('.lb-pendant-card');
      if (!card) return;
      var zoomBtn = e.target.closest('.lb-pendant-zoom');
      if (zoomBtn) {
        var zoomImg = card.querySelector('img');
        if (zoomImg && zoomImg.src) openZoom(zoomImg.src);
        return;
      }
      state.pendant2Id = card.dataset.pendantId;
      state.pendant2Price = parseFloat(card.dataset.pendantPrice) || 0;
      state.pendant2Name = card.dataset.pendantName || '';
      state.pendant2Image = card.querySelector('img') ? card.querySelector('img').src : '';
      pendantList2.querySelectorAll('.lb-pendant-card').forEach(function (c) { c.classList.remove('lb-pendant-card--selected'); });
      card.classList.add('lb-pendant-card--selected');
      updateSelections();
      updatePrice();
      updateCTA();
      saveState();
      setTimeout(function () { showStep(5); }, 300);
    });

    if (samePendantBtn) {
      samePendantBtn.addEventListener('click', function () {
        state.pendant2Id = state.pendant1Id; state.pendant2Price = state.pendant1Price;
        state.pendant2Name = state.pendant1Name; state.pendant2Image = state.pendant1Image;
        pendantList2.querySelectorAll('.lb-pendant-card').forEach(function (c) {
          c.classList.remove('lb-pendant-card--selected');
          if (c.dataset.pendantId === state.pendant1Id) c.classList.add('lb-pendant-card--selected');
        });
        updateSelections();
        updatePrice();
        updateCTA();
        saveState();
      });
    }

    // ---- Preselected Bead Card ----
    var preselectedBox = $('[data-role="preselected-bead"]');
    var preselectedImg = $('[data-role="preselected-bead-img"]');
    var preselectedName = $('[data-role="preselected-bead-name"]');
    var preselectedPrice = $('[data-role="preselected-bead-price"]');
    var preselectedRemove = $('[data-role="preselected-remove"]');

    function showPreselectedBead() {
      if (!state.pendant1Id || !preselectedBox) return;
      // Only show if the bead came from URL (not from list selection)
      if (!beadParamId) return;
      if (preselectedImg) preselectedImg.src = state.pendant1Image;
      if (preselectedName) preselectedName.textContent = state.pendant1Name;
      if (preselectedPrice) preselectedPrice.textContent = '$' + state.pendant1Price.toFixed(2);
      if (preselectedBox) preselectedBox.style.display = '';
    }

    function hidePreselectedBead() {
      beadParamId = ''; // Clear so it doesn't reappear
      if (preselectedBox) preselectedBox.style.display = 'none';
    }

    if (preselectedRemove) {
      preselectedRemove.addEventListener('click', function () {
        state.pendant1Id = null; state.pendant1Price = 0; state.pendant1Name = null; state.pendant1Image = null;
        hidePreselectedBead();
        refreshSelectedUI();
        updateSelections();
        updatePrice();
        updateCTA();
        saveState();
      });
    }

    // Show preselected bead from URL on load
    if (beadParamId) {
      showPreselectedBead();
      // Deep-linked from a product page — scroll the builder into view
      // (small delay so the page paints first and the smooth scroll is visible)
      setTimeout(function () {
        builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }

    // ---- Preset Combos ("TRY THIS" buttons elsewhere on the page) ----
    document.addEventListener('edc:apply-preset', function (e) {
      if (e.detail) applyPreset(e.detail);
    });

    function applyPreset(p) {
      var match = function (a, b) { return (a || '').trim().toLowerCase() === (b || '').trim().toLowerCase(); };

      // Step 1: rope (must match a configured cord type name)
      var ri = -1;
      for (var i = 0; i < allRopeData.length; i++) {
        if (match(allRopeData[i].name, p.ropeName)) { ri = i; break; }
      }
      if (ri === -1) return;
      clearDownstream(2);
      var rope = allRopeData[ri];
      state.ropeIndex = ri; state.ropeName = rope.name; state.ropeProductId = rope.productId; state.ropePrice = rope.price; state.ropeImage = rope.image;
      renderColors(rope.colors);

      // Step 2: color (must match one of the rope's color names)
      for (var ci = 0; ci < allColors.length; ci++) {
        if (match(allColors[ci].name, p.colorName)) {
          state.colorName = allColors[ci].name; state.colorImage = allColors[ci].image || '';
          break;
        }
      }

      // Step 3: weave (must match a configured braid style name)
      weaveCards.forEach(function (card) {
        if (match(card.dataset.weaveName, p.weaveName)) {
          state.weaveIndex = parseInt(card.dataset.weaveIndex, 10);
          state.weaveName = card.dataset.weaveName;
          state.weaveProductId = card.dataset.weaveProductId || null;
          state.weavePrice = parseFloat(card.dataset.weaveProductPrice) || 0;
          state.weaveNeedsTwo = card.dataset.weaveNeedsTwoPendants === 'true';
          state.weaveImage = card.querySelector('img') ? card.querySelector('img').src : '';
        }
      });

      // Step 4: beads (second bead defaults to the first when the style needs two)
      state.pendant1Id = p.bead1Id || null; state.pendant1Price = p.bead1Price || 0; state.pendant1Name = p.bead1Name || null; state.pendant1Image = p.bead1Img || null;
      if (state.weaveNeedsTwo) {
        view4b.style.display = '';
        if (samePendantBtn) samePendantBtn.style.display = 'block';
        if (p.bead2Id) {
          state.pendant2Id = p.bead2Id; state.pendant2Price = p.bead2Price || 0; state.pendant2Name = p.bead2Name || null; state.pendant2Image = p.bead2Img || null;
        } else {
          state.pendant2Id = state.pendant1Id; state.pendant2Price = state.pendant1Price; state.pendant2Name = state.pendant1Name; state.pendant2Image = state.pendant1Image;
        }
      } else {
        view4b.style.display = 'none'; view4b.classList.remove('lb-step-view--active');
        if (samePendantBtn) samePendantBtn.style.display = 'none';
        state.pendant2Id = null; state.pendant2Price = 0; state.pendant2Name = null; state.pendant2Image = null;
      }
      hidePreselectedBead();

      // Everything selected — jump straight to the notes step
      maxUnlockedStep = 5;
      updateSelections();
      updatePrice();
      updateCTA();
      showStep(5);
      if (builder.scrollIntoView) builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // ---- Default selections (first option of each step) ----
    // Applied on first visit (no saved state) so the builder always shows
    // a real starting price instead of $0.00 (Google Ads requirement).
    function applyDefaults() {
      // Step 1: first cord type
      if (allRopeData.length && (state.ropeIndex === null || !allRopeData[state.ropeIndex])) {
        var rope = allRopeData[0];
        state.ropeIndex = 0; state.ropeName = rope.name; state.ropeProductId = rope.productId; state.ropePrice = rope.price; state.ropeImage = rope.image;
        renderColors(rope.colors);
        // Step 2: first color of that cord
        if (rope.colors.length) {
          state.colorName = rope.colors[0].name || '';
          state.colorImage = rope.colors[0].image || '';
        }
      }

      // Step 3: first braid style
      if (weaveCards.length && state.weaveIndex === null) {
        var card = weaveCards[0];
        state.weaveIndex = parseInt(card.dataset.weaveIndex, 10);
        state.weaveName = card.dataset.weaveName;
        state.weaveProductId = card.dataset.weaveProductId || null;
        state.weavePrice = parseFloat(card.dataset.weaveProductPrice) || 0;
        state.weaveNeedsTwo = card.dataset.weaveNeedsTwoPendants === 'true';
        state.weaveImage = card.querySelector('img') ? card.querySelector('img').src : '';
        if (state.weaveNeedsTwo) {
          view4b.style.display = '';
          if (samePendantBtn) samePendantBtn.style.display = 'block';
        }
      }

      // Step 4: first bead (skipped when a bead was deep-linked via URL)
      var firstPendant = pendantList1 ? pendantList1.querySelector('.lb-pendant-card') : null;
      if (firstPendant && !state.pendant1Id) {
        state.pendant1Id = firstPendant.dataset.pendantId;
        state.pendant1Price = parseFloat(firstPendant.dataset.pendantPrice) || 0;
        state.pendant1Name = firstPendant.dataset.pendantName || '';
        state.pendant1Image = firstPendant.querySelector('img') ? firstPendant.querySelector('img').src : '';
      }
      // Two-pendant styles default the second bead to the first
      if (state.weaveNeedsTwo && !state.pendant2Id) {
        state.pendant2Id = state.pendant1Id; state.pendant2Price = state.pendant1Price;
        state.pendant2Name = state.pendant1Name; state.pendant2Image = state.pendant1Image;
      }

      maxUnlockedStep = 5;
    }

    // ---- Selected-state restore (step navigation & page load) ----
    function refreshSelectedUI() {
      ropeCards.forEach(function (c, i) {
        c.classList.toggle('lb-rope-card--selected', i === state.ropeIndex);
      });
      weaveCards.forEach(function (c) {
        c.classList.toggle('lb-weave-card--selected', state.weaveIndex !== null && parseInt(c.dataset.weaveIndex, 10) === state.weaveIndex);
      });
      markSelectedPendant(pendantList1, state.pendant1Id);
      markSelectedPendant(pendantList2, state.pendant2Id);
    }

    // Highlight the selected pendant if it is on the currently loaded/displayed page;
    // never auto-paginate — the bead may not even be loaded yet (lazy load)
    function markSelectedPendant(list, id) {
      if (!list) return;
      list.querySelectorAll('.lb-pendant-card').forEach(function (c) {
        c.classList.toggle('lb-pendant-card--selected', !!id && c.dataset.pendantId === String(id));
      });
    }

    // ---- Bottom Bar Chips ----
    function updateSelections() {
      if (state.ropeName) {
        chipRope.style.display = ''; chipRopeImg.src = state.ropeImage; chipRopeLabel.textContent = state.ropeName;
      } else { chipRope.style.display = 'none'; }
      if (state.colorName) {
        chipColor.style.display = ''; sepColor.style.display = '';
        chipColorImg.src = sizedImageUrl(state.colorImage, 300); chipColorLabel.textContent = state.colorName;
      } else { chipColor.style.display = 'none'; sepColor.style.display = 'none'; }
      if (state.weaveName) {
        chipWeave.style.display = ''; sepWeave.style.display = '';
        chipWeaveImg.src = state.weaveImage || '';
        chipWeaveLabel.textContent = state.weaveName;
      } else { chipWeave.style.display = 'none'; sepWeave.style.display = 'none'; }
      if (state.pendant1Name) {
        chipP1.style.display = ''; sepP1.style.display = '';
        chipP1Img.src = state.pendant1Image; chipP1Label.textContent = state.pendant1Name;
      } else { chipP1.style.display = 'none'; sepP1.style.display = 'none'; }
      if (state.pendant2Name) {
        chipP2.style.display = ''; sepP2.style.display = '';
        chipP2Img.src = state.pendant2Image; chipP2Label.textContent = state.pendant2Name;
      } else { chipP2.style.display = 'none'; sepP2.style.display = 'none'; }
      updateRecap();
    }

    // ---- Step 5 Recap (visible summary of the whole combo on the final step) ----
    function updateRecap() {
      if (!step5Recap) return;
      var items = [
        [state.ropeImage, state.ropeName],
        [state.colorImage, state.colorName],
        [state.weaveImage, state.weaveName],
        [state.pendant1Image, state.pendant1Name],
        [state.pendant2Image, state.pendant2Name]
      ].filter(function (it) { return it[1]; });
      if (!items.length) { step5Recap.style.display = 'none'; step5Recap.innerHTML = ''; return; }
      step5Recap.style.display = '';
      step5Recap.innerHTML = '';
      var label = document.createElement('span');
      label.className = 'lb-recap-label';
      label.textContent = 'Your combo:';
      step5Recap.appendChild(label);
      items.forEach(function (it, i) {
        if (i > 0) {
          var sep = document.createElement('span');
          sep.className = 'lb-recap-sep';
          sep.textContent = '+';
          step5Recap.appendChild(sep);
        }
        var chip = document.createElement('div');
        chip.className = 'lb-recap-item';
        if (it[0]) {
          var img = document.createElement('img');
          img.src = it[0]; img.alt = it[1]; img.width = 40; img.height = 40;
          chip.appendChild(img);
        }
        var name = document.createElement('span');
        name.textContent = it[1];
        chip.appendChild(name);
        step5Recap.appendChild(chip);
      });
    }

    // ---- Image Zoom Modal ----
    var zoomModal = $('[data-role="zoom-modal"]');
    var zoomImage = zoomModal ? zoomModal.querySelector('[data-role="zoom-image"]') : null;
    var zoomCloseBtns = zoomModal ? zoomModal.querySelectorAll('[data-role="zoom-close"]') : [];

    function openZoom(imgSrc) {
      if (zoomModal && zoomImage && imgSrc) {
        if (imgSrc.indexOf('cdn.shopify.com') > -1) {
          imgSrc = imgSrc.replace(/([?&])width=\d+/g, '');
          imgSrc += (imgSrc.indexOf('?') > -1 ? '&' : '?') + 'width=1000';
        }
        // Show a spinner until the (possibly slow) image finishes loading
        zoomModal.classList.add('lb-zoom-modal--loading');
        zoomImage.onload = function () {
          zoomModal.classList.remove('lb-zoom-modal--loading');
        };
        zoomImage.src = imgSrc;
        if (zoomImage.complete && zoomImage.naturalWidth > 0) {
          zoomModal.classList.remove('lb-zoom-modal--loading');
        }
        zoomModal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      }
    }

    function closeZoom() {
      if (zoomModal) {
        zoomModal.style.display = 'none';
        zoomModal.classList.remove('lb-zoom-modal--loading');
        if (zoomImage) { zoomImage.onload = null; zoomImage.src = ''; }
        document.body.style.overflow = '';
      }
    }

    zoomCloseBtns.forEach(function (el) { el.addEventListener('click', closeZoom); });

    // Attach click-to-zoom on bottom bar chips
    [chipRope, chipColor, chipWeave, chipP1, chipP2].forEach(function (chip) {
      if (!chip) return;
      chip.addEventListener('click', function (e) {
        // Don't trigger if clicking the zoom icon on pendant chips
        if (e.target.closest('.lb-pendant-zoom')) return;
        var img = chip.querySelector('img');
        if (img && img.src) openZoom(img.src);
      });
    });

    // ---- Price (client-side display) ----
    function updatePrice() {
      var total = state.ropePrice + state.weavePrice + state.pendant1Price + state.pendant2Price;
      totalPriceEl.textContent = '$' + total.toFixed(2);
    }

    // ---- CTA ----
    function updateCTA() {
      var haveAll = state.ropeIndex !== null && state.ropeProductId && state.colorName !== null &&
                    state.weaveIndex !== null && state.weaveProductId && state.pendant1Id;
      var needP2 = state.weaveNeedsTwo && !state.pendant2Id;
      var canAdd = haveAll && !needP2;
      addToCartBtn.disabled = !canAdd;
      if (state.ropeIndex === null) addToCartBtn.textContent = 'Add To Cart';
      else if (!state.colorName) addToCartBtn.textContent = 'Pick a Color';
      else if (state.weaveIndex === null) addToCartBtn.textContent = 'Pick a Weave';
      else if (!state.pendant1Id) addToCartBtn.textContent = 'Pick a Pendant';
      else if (needP2) addToCartBtn.textContent = 'Pick 2nd Pendant';
      else addToCartBtn.textContent = 'Add to Cart';
    }

    // ---- Add to Cart (multi-item) ----
    addToCartBtn.addEventListener('click', function () {
      if (addToCartBtn.disabled) return;
      addToCartBtn.disabled = true; addToCartBtn.textContent = 'Adding...'; errorEl.style.display = 'none';

      var bundleId = 'EDC-' + Date.now();
      var totalLen = noteTotalLength ? noteTotalLength.value.trim() : '';
      var loopLen = noteLoopLength ? noteLoopLength.value.trim() : '';
      var knotCnt = noteKnotCount ? noteKnotCount.value.trim() : '';
      var customLet = noteCustomLetter ? noteCustomLetter.value.trim() : '';
      var otherNotes = noteOther ? noteOther.value.trim() : '';
      var bundleLabel = state.ropeName + '(' + state.colorName + ') + ' + state.weaveName;
      if (state.pendant1Name) bundleLabel += ' + ' + state.pendant1Name;
      if (state.pendant2Name) bundleLabel += ' + ' + state.pendant2Name;

      var items = [];

      // Rope product
      items.push({
        id: parseInt(state.ropeProductId, 10),
        quantity: 1,
        properties: {
          '_bundle_id': bundleId,
          '_bundle_label': bundleLabel,
          'Bundle': bundleId,
          'Cord Type': state.ropeName,
          'Cord Color': state.colorName,
          'Total Length': totalLen,
          'Loop Length': loopLen,
          'Knot Count': knotCnt,
          'Custom Letter': customLet,
          'Other Notes': otherNotes,
        },
      });

      // Braid Style product
      items.push({
        id: parseInt(state.weaveProductId, 10),
        quantity: 1,
        properties: {
          '_bundle_id': bundleId,
          '_bundle_label': bundleLabel,
          'Bundle': bundleId,
          'Braid Style': state.weaveName,
          'Total Length': totalLen,
          'Loop Length': loopLen,
          'Knot Count': knotCnt,
          'Custom Letter': customLet,
          'Other Notes': otherNotes,
        },
      });

      // Bead 1
      items.push({
        id: parseInt(state.pendant1Id, 10),
        quantity: 1,
        properties: {
          '_bundle_id': bundleId,
          '_bundle_label': bundleLabel,
          'Bundle': bundleId,
          'Total Length': totalLen,
          'Loop Length': loopLen,
          'Knot Count': knotCnt,
          'Custom Letter': customLet,
          'Other Notes': otherNotes,
        },
      });

      // Bead 2 (if selected)
      if (state.pendant2Id) {
        items.push({
          id: parseInt(state.pendant2Id, 10),
          quantity: 1,
          properties: {
            '_bundle_id': bundleId,
            '_bundle_label': bundleLabel,
            'Bundle': bundleId,
            'Total Length': totalLen,
          'Loop Length': loopLen,
          'Knot Count': knotCnt,
          'Custom Letter': customLet,
          },
        });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) { if (!res.ok) throw new Error(''); return res.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          errorEl.textContent = 'Could not add to cart. Please try again.';
          errorEl.style.display = 'block'; addToCartBtn.disabled = false; updateCTA();
        });
    });

    // ---- Pagination Helper ----
    function makePagination(type, page, totalPages, onPrev, onNext) {
      var bar = document.createElement('div');
      bar.className = 'lb-pagination';
      bar.setAttribute('data-pagination', type);

      var prev = document.createElement('button');
      prev.className = 'lb-page-btn';
      prev.type = 'button';
      prev.innerHTML = '<span class="lb-page-arrow">&#9664;</span> Prev';
      prev.disabled = page <= 0;
      if (onPrev) prev.addEventListener('click', onPrev);
      bar.appendChild(prev);

      var info = document.createElement('span');
      info.className = 'lb-page-info';
      info.textContent = (page + 1) + ' / ' + totalPages;
      bar.appendChild(info);

      var next = document.createElement('button');
      next.className = 'lb-page-btn';
      next.type = 'button';
      next.innerHTML = 'Next <span class="lb-page-arrow">&#9654;</span>';
      next.disabled = page >= totalPages - 1;
      if (onNext) next.addEventListener('click', onNext);
      bar.appendChild(next);

      return bar;
    }

    // ---- Init pendant pagination (called above, defined here) ----

    // ---- Pendant Pagination ----
    var pendantPage1 = 0;
    var pendantPage2 = 0;

    function pendantMove(listId, dir) {
      var list = listId === 1 ? pendantList1 : pendantList2;
      var loaded = list.querySelectorAll('.lb-pendant-card').length;
      var loadedPages = Math.ceil(loaded / PENDANTS_PER_PAGE) || 1;
      var page = listId === 1 ? pendantPage1 : pendantPage2;

      // Trigger load-more if NEXT page won't be full AND server has more
      var nextPage = page + dir;
      var itemsOnNextPage = loaded - (nextPage * PENDANTS_PER_PAGE);
      var nextPageWouldBeShort = (dir > 0 && nextPage >= loadedPages - 1 && itemsOnNextPage < PENDANTS_PER_PAGE);
      if (nextPageWouldBeShort && loaded < pendantTotal) {
        list.classList.add('lb-pendants--loading');
        var serverPage = Math.ceil(loaded / 20) + 1;
        fetch('/collections/' + pendantCollectionHandle + '/products.json?page=' + serverPage + '&limit=20')
          .then(function (r) { if (!r.ok) throw new Error(''); return r.json(); })
          .then(function (d) {
            list.classList.remove('lb-pendants--loading');
            if (d.products && d.products.length) {
              d.products.forEach(function (p) {
                var v = p.variants[0];
                var price = parseFloat(v.price) || 0;
                var card = document.createElement('button');
                card.className = 'lb-pendant-card';
                card.setAttribute('data-pendant-id', v.id);
                card.setAttribute('data-pendant-price', price.toFixed(2));
                card.setAttribute('data-pendant-name', p.title);
                card.setAttribute('data-product-url', p.url || '');
                var src = (p.images && p.images[0] && p.images[0].src) ||
                          (p.image && (typeof p.image === 'string' ? p.image : p.image.src)) ||
                          (typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image && p.featured_image.src)) ||
                          '';
                if (src && src.indexOf('//') === 0) src = 'https:' + src;
                if (src && src.indexOf('cdn.shopify.com') > -1 && src.indexOf('width=') === -1) src += '&width=500';
                var imgEl = document.createElement('img');
                imgEl.src = src; imgEl.alt = p.title; imgEl.width = 100; imgEl.height = 100;
                card.appendChild(imgEl);
                var ns = document.createElement('span'); ns.className = 'lb-pendant-name'; ns.textContent = p.title;
                card.appendChild(ns);
                var ps = document.createElement('span'); ps.className = 'lb-pendant-price';
                ps.textContent = '$' + price.toFixed(2);
                card.appendChild(ps);
                var zoom = document.createElement('span');
                zoom.className = 'lb-pendant-zoom';
                zoom.title = 'Enlarge image';
                zoom.setAttribute('role', 'button');
                zoom.setAttribute('aria-label', 'Enlarge image');
                zoom.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><line x1="15.5" y1="15.5" x2="21" y2="21"/><line x1="10.5" y1="7.5" x2="10.5" y2="13.5"/><line x1="7.5" y1="10.5" x2="13.5" y2="10.5"/></svg>';
                card.appendChild(zoom);
                list.appendChild(card);
              });
            }
            if (listId === 1) pendantPage1++; else pendantPage2++;
            refreshPendantBar(listId);
          }).catch(function () { list.classList.remove('lb-pendants--loading'); });
        return;
      }

      var newPage = page + dir;
      if (newPage < 0 || newPage >= loadedPages) return;
      if (listId === 1) pendantPage1 = newPage; else pendantPage2 = newPage;
      refreshPendantBar(listId);
    }

    function refreshPendantBar(listId) {
      var list = listId === 1 ? pendantList1 : pendantList2;
      var loaded = list.querySelectorAll('.lb-pendant-card').length;
      var loadedPages = Math.ceil(loaded / PENDANTS_PER_PAGE) || 1;
      var page = listId === 1 ? pendantPage1 : pendantPage2;
      page = Math.min(Math.max(page, 0), loadedPages - 1);
      if (listId === 1) pendantPage1 = page; else pendantPage2 = page;

      var oldBar = document.querySelector('[data-pagination="pendant' + listId + '"]');
      if (oldBar) oldBar.remove();

      var cards = list.querySelectorAll('.lb-pendant-card');
      var start = page * PENDANTS_PER_PAGE;
      var end = start + PENDANTS_PER_PAGE;
      cards.forEach(function (card, i) {
        card.style.display = (i >= start && i < end) ? '' : 'none';
      });

      var displayTotal = pendantTotal > 0 ? pendantTotal : loaded;
      var displayPages = Math.ceil(displayTotal / PENDANTS_PER_PAGE) || 1;
      var hasMore = loaded < pendantTotal;

      var bar = makePagination('pendant' + listId, page, displayPages,
        function () { pendantMove(listId, -1); },
        function () { pendantMove(listId, 1); }
      );
      list.after(bar);

      if (hasMore && page >= displayPages - 1) {
        bar.querySelector('[data-page-action="next"]').disabled = false;
      }
    }

    function initPendantPagination(list, loadMoreBtn, listId) {
      refreshPendantBar(listId);
    }

    // Save notes to localStorage on input
    [noteTotalLength, noteLoopLength, noteKnotCount, noteCustomLetter, noteOther].forEach(function (el) {
      if (el) el.addEventListener('input', saveState);
    });

    // ---- Init pendant pagination ----
    initPendantPagination(pendantList1, loadMore1, 1);
    initPendantPagination(pendantList2, loadMore2, 2);

    // ---- Restore saved state (localStorage / URL params) ----
    if (state.ropeIndex !== null && allRopeData[state.ropeIndex]) {
      renderColors(allRopeData[state.ropeIndex].colors);
      if (state.weaveIndex !== null && state.weaveNeedsTwo) {
        view4b.style.display = '';
        if (samePendantBtn) samePendantBtn.style.display = 'block';
      }
      updateSelections();
      updatePrice();
      updateCTA();
      showStep(currentStep);
    } else {
      // First visit — preselect the first option of each step so a real
      // starting price is shown immediately (Google Ads requirement)
      applyDefaults();
      showStep(1);
      updateSelections();
      updatePrice();
      updateCTA();
    }
  }
})();
